import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import {Select} from "components/form";
import repository from "client/repository";
import {AzureRegionResource} from "client/resources/azureRegionResource";
import {RegionPublicIpPrefixSku} from "client/resources/regionPublicIpPrefixRequests";
import {AdministratorRoleCallout} from "shared/AdministratorRoleCallout";

// StandardV2 prefixes are for NAT Gateway V2 egress, which needs fewer IP addresses than a Standard load balancer
const defaultPrefixLengths: Record<RegionPublicIpPrefixSku, number> = {
    Standard: 28,
    StandardV2: 29,
};

interface Props {
    azureRegion: AzureRegionResource;
    onTaskStarted: (taskId: string) => void;
}

interface State extends DataBaseComponentState {
    sku: RegionPublicIpPrefixSku;
    prefixLength: number;
}

class AddRegionPublicIpPrefixDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            sku: "Standard",
            prefixLength: defaultPrefixLengths.Standard,
        };
    }

    render() {
        return <SaveDialogLayout title="Add IP Prefix"
                                 saveButtonLabel="Add"
                                 busy={this.state.busy}
                                 errors={this.state.errors}
                                 onSaveClick={this.add}>
            <AdministratorRoleCallout action="add an IP prefix to an Azure Region"/>
            <p>Create a new Public IP Prefix in the {this.props.azureRegion.Region} Azure Region?</p>
            <p>It won't be shared with customers until it's published and the region's IP ranges are republished, and reefs won't use it until it's made available.</p>
            <Select label="SKU"
                    value={this.state.sku}
                    onChange={(sku: RegionPublicIpPrefixSku) => this.setState({sku, prefixLength: defaultPrefixLengths[sku]})}
                    items={[
                        {value: "Standard", text: "Standard (load balancer egress)"},
                        {value: "StandardV2", text: "StandardV2 (NAT Gateway V2 egress)"},
                    ]}/>
            <Select label="Prefix size"
                    value={this.state.prefixLength.toString()}
                    onChange={(prefixLength: string) => this.setState({prefixLength: Number(prefixLength)})}
                    items={[
                        {value: "28", text: "/28 (16 IP addresses)"},
                        {value: "29", text: "/29 (8 IP addresses)"},
                    ]}/>
        </SaveDialogLayout>;
    }

    private add = (): Promise<boolean> => {
        return this.doBusyTask(async () => {
            const taskId = await repository.AzureRegions.addPublicIpPrefix(this.props.azureRegion.Id, {Sku: this.state.sku, PrefixLength: this.state.prefixLength});
            this.props.onTaskStarted(taskId);
        });
    }
}

export default AddRegionPublicIpPrefixDialog;
